<template>
  <div v-if="ready" class="text-gray">
    <div v-if="currentDateWeather" class="weather-forecast">
      <div class="row">
        <div class="col-7">
          <div class="gradient full-height pl-3 pr-3">
            <div class="row full-height">
              <div class="col-4 full-height text-center vertical-center" style="min-height: 93px">
                <div class="full-width">
                  <div>
                    {{ currentDateWeather.weekday }}
                    {{ currentDateWeather.relativeDay }}
                  </div>
                  <div class="text-uppercase font-weight-bold">{{ city }}</div>
                  <div>WEATHER</div>
                </div>
              </div>
              <div class="col-4 full-height text-center vertical-center">
                <div class="full-width">
                  <font-awesome-icon :icon="['fal', currentDateWeather.icon]" class="text-50" />
                </div>
              </div>
              <div class="col-4 full-height text-center vertical-center">
                <div class="full-width">
                  <div>
                    {{ currentDateWeather.temp_min }}&#8451; -
                    {{ currentDateWeather.temp_max }}&#8451;
                  </div>
                  <div class="text-capitalize">
                    {{ currentDateWeather.short_text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-5">
          <div class="row">
            <div v-if="dayPlus1" class="col-4 text-center">
              <div class="text-12">{{ dayPlus1.weekday }}</div>
              <template v-if="dayPlus1.icon">
                <div class="pt-2 pb-1">
                  <font-awesome-icon :icon="['fal', dayPlus1.icon]" class="text-24" />
                </div>
                <div class="text-12 high">{{ dayPlus1.temp_max }}&#8451;</div>
                <div class="text-12 low">{{ dayPlus1.temp_min }}&#8451;</div>
              </template>
              <div v-else class="pt-3">No<br />Data</div>
            </div>
            <div v-if="dayPlus2" class="col-4 text-center">
              <div class="text-12">{{ dayPlus2.weekday }}</div>
              <template v-if="dayPlus2.icon">
                <div class="pt-2 pb-1">
                  <font-awesome-icon :icon="['fal', dayPlus2.icon]" class="text-24" />
                </div>
                <div class="text-12 high">{{ dayPlus2.temp_max }}&#8451;</div>
                <div class="text-12 low">{{ dayPlus2.temp_min }}&#8451;</div>
              </template>
              <div v-else class="pt-3">No<br />Data</div>
            </div>
            <div v-if="dayPlus3" class="col-4 text-center">
              <div class="text-12">{{ dayPlus3.weekday }}</div>
              <template v-if="dayPlus3.icon">
                <div class="pt-2 pb-1">
                  <font-awesome-icon :icon="['fal', dayPlus3.icon]" class="text-24" />
                </div>
                <div class="text-12 high">{{ dayPlus3.temp_max }}&#8451;</div>
                <div class="text-12 low">{{ dayPlus3.temp_min }}&#8451;</div>
              </template>
              <div v-else class="pt-3">No<br />Data</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <font-awesome-icon :icon="['fal', 'cloud']" class="text-40" />
        <span style="position: relative; top: -10px; left: 12px">No weather data available...</span>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import moment from "moment/moment";

export default {
  props: {
    postcode: {
      type: [Number, String],
      required: true,
    },

    city: {
      type: String,
    },

    date: {
      type: String,
    },
  },

  data() {
    return {
      weather: null,

      dayPlus1: null,
      dayPlus2: null,
      dayPlus3: null,

      ready: false,
    };
  },

  computed: {
    currentDateWeather() {
      if (!this.date || !this.postcode || !this.weather || !this.weather[this.date]) {
        return null;
      }

      return this.weather[this.date];
    },
  },

  watch: {
    date() {
      this.init();
    },

    postcode() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.ready = false;
      this.weather = null;
      this.dayPlus1 = null;
      this.dayPlus2 = null;
      this.dayPlus3 = null;

      if (!this.date) {
        this.date = moment().format("YYYY-MM-DD");
      }

      if (this.postcode) {
        this.weather = await this.$store.dispatch("weather/getData", this.postcode);

        this.dayPlus1 = this.getWeatherByDatePlus(1);
        this.dayPlus2 = this.getWeatherByDatePlus(2);
        this.dayPlus3 = this.getWeatherByDatePlus(3);
      }

      this.ready = true;
    },

    getWeatherByDate(date) {
      if (!this.weather) {
        return null;
      }

      if (!this.weather[date]) {
        let weekday = moment(date).format("ddd");

        return {
          date: date,
          icon: null,
          icon_descriptor: null,
          short_text: null,
          temp_max: null,
          temp_min: null,
          weekday: weekday,
        };
      }

      return this.weather[date];
    },

    getWeatherByDatePlus(plus) {
      const targetDate = moment(this.date).add(plus, "days").format("YYYY-MM-DD");

      return this.getWeatherByDate(targetDate);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.weather-forecast .gradient {
  background: rgb(255, 255, 255);
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(212, 212, 212, 0.5) 100%);
}

.weather-forecast .vertical-center {
  display: flex;
  align-items: center;
}

.weather-forecast .high {
  color: #ff7a00;
}

.weather-forecast .low {
  color: #36a9e1;
}
</style>
